import React from 'react';

import IntlMessages from 'util/IntlMessages';

export const secondDimensionOptions = [
  {
    label: <IntlMessages id="dashboards.events.countChart.secondDimension.users" />,
    value: 'user.id',
  },
  {
    label: <IntlMessages id="dashboards.events.countChart.secondDimension.eventTypes" />,
    value: 'trigger.id',
  },
];

export const DISPLAY_TYPES = [
  {
    label: 'Bar',
    value: 'bar',
  },
  {
    label: 'Line',
    value: 'line',
  },
];
